export default class YoutubeLoader {
    constructor() {
        this._loading = false
        this._onload = []
        this._re = /.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=)([^#&?]*).*/
    }

    get ready() { return !!window.YT }

    load() {
        if (this._loading || this.ready) {
            return
        }

        this._loading = true
        window.onYouTubeIframeAPIReady = () => {
            this._loading = false
            this._onload = this._onload.filter(fun => {
                fun(window.YT)
                return false
            })
        }

        let tag = document.createElement('script')
        tag.setAttribute('async', 'true')
        tag.setAttribute('defer', 'true')
        tag.src = 'https://www.youtube.com/iframe_api'
        document.head.appendChild(tag)
    }

    parseVideoID(url) {
        let matches = url.match(this._re)
        return matches ? matches[1] : false
    }

    api(callback) {
        if (this.ready) {
            callback(window.YT)
        } else {
            this.load()
            this._onload.push(callback)
        }
    }
}
